import bem from 'utils/bem';

export const block = bem('threads-autopost-modal');
